import React from 'react';
import { isEventFinished } from '../../../../../../data/filters/events/isEventFinished';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';
import Button from '../../../../../elements/Button';
import DownloadLeadsButton from '../DownloadLeadsButton';
import ScanLeadIcon from './scan_icon_white.svg';

function ScanLeadButton(props) {
    const { className = '', href = './scan', event } = props,
        i18n = useI18n();

    if (isEventFinished(event)) return <DownloadLeadsButton className={className} event={event} />;

    return (
        <Button className={[className, 'primary'].join(' ')} href={href}>
            <ScanLeadIcon className="marginRight" />
            {i18n['label.scan']}
        </Button>
    );
}

export default ScanLeadButton;
